var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGitlab = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 27 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E24329",
  d: "m26.562 10.3-.035-.105L22.849.607a.9.9 0 0 0-.382-.45A1.1 1.1 0 0 0 21.895 0a.9.9 0 0 0-.555.208.92.92 0 0 0-.33.503l-2.48 7.594H8.484L6.004.711a1.06 1.06 0 0 0-.33-.503A.9.9 0 0 0 5.12 0c-.208 0-.399.035-.572.156a.9.9 0 0 0-.382.45l-3.678 9.59-.035.103c-1.092 2.844-.156 6.052 2.273 7.89h.035c0 .017 5.603 4.213 5.603 4.213L11.14 24.5l1.683 1.266a1.12 1.12 0 0 0 1.37 0l1.683-1.266 2.776-2.098 5.638-4.213a6.814 6.814 0 0 0 2.255-7.89z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FC6D26",
  d: "m25.578 9.917-.033-.1a12.1 12.1 0 0 0-4.758 2.137c-.017 0-4.208 3.188-7.78 5.876 2.638 2.004 4.941 3.74 4.941 3.74l5.426-4.057a6.56 6.56 0 0 0 2.17-7.596z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCA326",
  d: "m8.048 21.57 2.672 2.02 1.619 1.219c.384.3.935.3 1.319 0l1.62-1.219 2.67-2.02s-2.303-1.736-4.941-3.74c-2.655 2.004-4.959 3.74-4.959 3.74"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FC6D26",
  d: "M5.227 11.954A11.85 11.85 0 0 0 .469 9.817l-.034.1a6.57 6.57 0 0 0 2.187 7.596h.034c0 .017 5.392 4.057 5.392 4.057s2.304-1.736 4.959-3.74c-3.556-2.688-7.747-5.86-7.78-5.876"
})));
export default SvgGitlab;